import React from 'react';
import { Icon } from 'antd';

export const SpinIndicator = ({ component, ...props }) => {
  return (
    <Icon
      spin={true}
      style={{ fontSize: '24px', color: '#3378f9' }}
      component={component}
      {...props}
    />
  );
};
